import { RootState } from "./../../app/store/index";
import { useSelector } from "react-redux";

function useSessionUser() {
  const sessionUser = useSelector((state: RootState) => state.rootReducer.sessionUser);
  return sessionUser;
}

export default useSessionUser;
